<template>
  <div class="flex flex-col mt-3">
    <Modal
      ref="studentSelectorModal"
      size="full"
      width="max"
      anchor="center">
      <template #title>Select Student</template>
      <template #content>
        <form>
          <SearchForm
            v-model="search"
            @search="onSearch"
          />
        </form>
        <div class="flex flex-row p-2 mb-2 gap-2 bg-gray-200 rounded-md">
          <div class="w-72">
            <SelectionField
              v-model="schoolYear"
              :options="schoolYearOptions"
              :disabled="displayLoadingStudentsSpinner"
              @input="onSchoolYearSelected">
              School Year
            </SelectionField>
          </div>
          <div class="flex flex-row">
            <VSelectionField class="w-96"
              v-model="districtCode"
              :options="districtOptions"
              :disabled="displayLoadingDistrictsSpinner"
              @input="onDistrictSelected">
              District
            </VSelectionField>
            <Spinner
              v-if="displayLoadingDistrictsSpinner"
              message="Loading Districts"
              :size="4"
            />
          </div>
        </div>
        <div class="flex flex-row p-2 mb-2 bg-gray-200 gap-2 rounded-md justify-items-center"
          v-if="pageDisplay.length > 0">
          <div class="p-1 bg-blue-200 hover:bg-sky-600 rounded-sm"
            v-for="pageNumber in pageDisplay"
            :key="pageNumber"
            @click="changePage(pageNumber)">
            {{ pageNumber }}
          </div>
        </div>
        <div class="flex flex-col p-2 bg-gray-200 rounded-md">
          <div class="flex flex-row">
            <div class="pr-1"
              v-if="schoolYear === undefined">
              Select School Year,
            </div>
            <div
              v-if="districtCode === undefined">
              Select District
            </div>
          </div>
          <Spinner
            v-if="displayLoadingStudentsSpinner"
            message="Loading Students"
            :size="16"
          />
          <div class="px-2 bg-blue-200 font-bold rounded-md"
            v-if="search">
            {{ search }}
          </div>
          <div
            v-for="student in displayStudents"
            :key="student.id">
            <div class="flex flex-row hover:bg-gray-100"
              :class="{
                'border-black': selectedStudentId === student.db_id,
                'border-2': selectedStudentId === student.db_id,
                'border-lg': selectedStudentId === student.db_id,
                'border-0': selectedStudentId !== student.db_id,
              }"
              @click="selectEntry(student.db_id)">
              <span class="px-2 w-24">
                {{ student.db_id }}
              </span>
              <span class="px-2 w-72">
                {{ student.internal_id }}
              </span>
              <span class="px-2 min-w-72 max-w-full">
                {{ student.first_name }} {{ student.last_name }}
              </span>
            </div>
          </div>
        </div>
        <div class="flex flex-row p-2 mt-2 bg-gray-200 gap-2 rounded-md justify-items-center"
          v-if="pageDisplay.length > 0">
          <div class="p-1 bg-blue-200 hover:bg-sky-600 rounded-sm"
            v-for="pageNumber in pageDisplay"
            :key="pageNumber"
            @click="changePage(pageNumber)">
            {{ pageNumber }}
          </div>
        </div>
      </template>
      <template #footer>
        <Button class="rounded-md px-3 py-2 transition-colors shadow-sm"
          color="blue"
          @click="addValue">
          Add
        </Button>
      </template>
    </Modal>
  </div>
</template>


<script>
import Modal from '../../Modal.vue'
import Button from '../../Button.vue'
import Spinner from '../../Spinner.vue'
// import TextField from '../../formComponents/TextField.vue'
import SearchForm from '../../Search/SearchForm.vue'
import SelectionField from '../../formComponents/SelectionField.vue'
import VSelectionField from '../../formComponents/VSelectionField.vue'

import { filter, map } from 'lodash'

import userManagementService from '../../../services/pages/userManagement.js'

import DROPDOWN_LISTS from '../../DropdownLists.json'

export default {
  components: {
    Modal,
    Button,
    Spinner,
    // TextField,
    SearchForm,
    SelectionField,
    VSelectionField,
  },
  props: {},
  data() {
    return {
      schoolYear: undefined,
      schoolYearOptions: DROPDOWN_LISTS.schoolYears,

      districtCode: undefined,
      districts: {},

      students: {},
      studentsArray: [],
      page: 1,
      numPage: 100,
      selectedStudentId: undefined,

      displayLoadingDistrictsSpinner: false,
      displayLoadingStudentsSpinner: false,

      search: undefined,
      formValues: undefined,
    }
  },
  mounted() {
    userManagementService.registerSelectorModal(
      'student',
      () => {
        this.$refs['studentSelectorModal'].openModal()
        this.displayLoadingDistrictsSpinner = true
        userManagementService.getConfigContent(['district', 'partition'])
          .then((data) => {
            this.displayLoadingDistrictsSpinner = false
            this.districts = data['districts']
          })
      },
      () => {
        this.$refs['studentSelectorModal'].closeModal()
      },
    )
  },
  methods: {
    changePage(pageNumber) {
      this.page = pageNumber
    },
    onSchoolYearSelected() {
      if (this.districtCode !== undefined && this.schoolYear !== undefined) {
        this.getConfigContent()
      }
    },
    onDistrictSelected() {
      if (this.districtCode !== undefined && this.schoolYear !== undefined) {
        this.getConfigContent()
      }
    },
    getConfigContent() {
      this.displayLoadingStudentsSpinner = true
      userManagementService.getConfigContent(
        ['student'],
        {
          schoolYear: this.schoolYear,
          districtCode: this.districtCode,
        }
      ).then((data) => {
        this.displayLoadingStudentsSpinner = false
        this.students = data['students']
        this.studentsArray = Object.values(this.students)
      })
    },
    selectEntry(studentId) {
      this.selectedStudentId = studentId
    },
    onSearch() {
      console.log('onSearch')
    },
    addValue() {
      userManagementService.closeSelectorModal('student', this.students[this.selectedStudentId])
      this.selectedStudentId = undefined
    },
  },
  computed: {
    filteredStudents() {
      if (this.search) {
        return filter(this.studentsArray, (student) => {          
          return student.internal_id?.toLowerCase().includes(this.search.toLowerCase()) ||
            student.first_name?.toLowerCase().includes(this.search.toLowerCase()) ||
            student.last_name?.toLowerCase().includes(this.search.toLowerCase())
        })
      }
      else {
        return this.studentsArray
      }
    },
    displayStudents() {
      return this.filteredStudents.slice((this.page - 1) * this.numPage, this.page * this.numPage)
    },
    pageDisplay() {
      let length = Object.keys(this.filteredStudents).length
      let rangeMaxValue = Math.ceil(length / this.numPage) + 1
      return [...Array(rangeMaxValue).keys()].slice(1, rangeMaxValue)
    },
    districtOptions() {
      return map(this.districts, (district) => {
        return {
          'value': district.code,
          'label': `${district.code} -- ${district.name}`,
        }
      })
    }
  },
}
</script>
